// BlogWriter.tsx
import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader } from '../../../components/ui/card';
import { BlogWriterHeader } from '../components/History/BlogWriterHeader';
import { ActionButtons } from '../components/History/ActionButtons';
import { FolderList } from '../components/History/FolderList';
// import { BlogTable } from '../components/History/BlogTable';
import { ToolsGrid } from '../components/History/ToolsGrid';
import { folderService } from '../services/folderApi';
import { BlogResponse } from '../services/blogApi';
import { FolderResponse } from '../services/folderApi';
import toast from 'react-hot-toast';
import BlogTableWithTabs from '../components/History/SharedBlogsTab';
import TrendingTools from 'features/files/components/common/TrendingTools';

export const BlogWriter: React.FC = () => {
  const [folders, setFolders] = useState<FolderResponse[]>([]);
  const [activeFolderId, setActiveFolderId] = useState<number | null>(null);
  const [activeBlogs, setActiveBlogs] = useState<BlogResponse[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [tools] = useState([
    { id: '1', name: 'Tool 1', description: 'Description 1' },
    { id: '2', name: 'Tool 2', description: 'Description 2' },
    { id: '3', name: 'Tool 3', description: 'Description 3' },
    { id: '4', name: 'Tool 4', description: 'Description 4' },
  ]);

  // Fetch folders on component mount
  useEffect(() => {
    fetchFolders();
  }, []);

  // Fetch blogs when active folder changes
  useEffect(() => {
    if (activeFolderId) {
      fetchFolderFiles(activeFolderId);
    } else {
      setActiveBlogs([]);
    }
  }, [activeFolderId]);

  const fetchFolders = async () => {
    try {
      setIsLoading(true);
      const response = await folderService.getAllFolders();
      if (response.success && response.data) {
        setFolders(response.data);

        if (response.data.length > 0 && !activeFolderId) {
          setActiveFolderId(response.data[0].id);
        }
      }
    } catch (error) {
      console.log(error);
      toast.error('Failed to load folders');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchFolderFiles = async (folderId: number) => {
    try {
      const response = await folderService.getFolderFiles(folderId);
      if (response.success && response.data) {
        setActiveBlogs(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleNewFolder = async (folderName: string) => {
    try {
      const response = await folderService.createFolder(folderName);
      if (response.success && response.data) {
        setFolders([...folders, response.data]);
        toast.success('Folder created successfully');
      }
    } catch (error) {
      console.log(error);
      toast.error('Failed to create folder');
    }
  };

  const handleUpdateFolder = async (folderId: number, newName: string) => {
    try {
      const response = await folderService.updateFolder(folderId, newName);
      if (response.success && response.data) {
        setFolders(
          folders.map((folder) =>
            folder.id === folderId ? response.data : folder
          )
        );
        toast.success('Folder updated successfully');
      }
    } catch (error) {
      console.log(error);
      toast.error('Failed to update folder');
    }
  };

  const handleDeleteFolder = async (folderId: number) => {
    try {
      const response = await folderService.deleteFolder(folderId);
      if (response.success) {
        setFolders(folders.filter((folder) => folder.id !== folderId));
        if (activeFolderId === folderId) {
          setActiveFolderId(folders[0]?.id ?? null);
        }
        toast.success('Folder deleted successfully');
      }
    } catch (error) {
      console.log(error);
      toast.error('Failed to delete folder');
    }
  };

  const handleFolderSelect = (folderId: number) => {
    setActiveFolderId(folderId);
  };

  // const handleNewBlog = async (data: {
  //   title: string;
  //   context: string;
  //   file_name: string;
  //   folder_id: string | null;
  //   images_urls: string;
  //   topic: string;
  //   min_len: string;
  //   max_len: string;
  //   language: string;
  //   tone: string;
  //   industry: string;
  //   no_of_images: number;
  // }) => {
  //   if (!activeFolderId) {
  //     toast.error('Please select a folder first');
  //     return;
  //   }

  //   try {
  //     const response = await blogService.saveBlog({
  //       ...data,
  //       folder_id: String(activeFolderId),
  //     });

  //     if (response.success) {
  //       // Refresh the folder files
  //       fetchFolderFiles(activeFolderId);
  //       toast.success('Blog created successfully');
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     toast.error('Failed to create blog');
  //   }
  // };

  return (
    <div className="flex flex-col w-full h-full gap-6">
      <BlogWriterHeader />

      <Card className="flex-1 bg-background-main border-0 ">
        <CardHeader className="flex flex-row items-center justify-between p-6 text-text-primary">
          <div>
            <h2 className="text-xl font-semibold">Your Blogs</h2>
            <p className="text-sm">Manage your blogs and folders</p>
          </div>
          <ActionButtons
            onNewFolder={handleNewFolder}
            // onNewBlog={handleNewBlog}
            // disabled={!activeFolderId}
          />
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-4  gap-4 text-text-primary">
            <div className="rounded-lg p-4">
              <h3 className="font-medium mb-4">Folders</h3>
              <FolderList
                folders={folders}
                activeFolderId={activeFolderId}
                onFolderSelect={handleFolderSelect}
                onUpdateFolder={handleUpdateFolder}
                onDeleteFolder={handleDeleteFolder}
                isLoading={isLoading}
              />
            </div>
            <div className="md:col-span-3">
              <div className="md:col-span-3">
                <BlogTableWithTabs
                  blogs={activeBlogs}
                  onRefresh={() =>
                    activeFolderId && fetchFolderFiles(activeFolderId)
                  }
                  isLoading={isLoading}
                />
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* <ToolsGrid tools={tools} /> */}
      <TrendingTools />
    </div>
  );
};

export default BlogWriter;
